import { createContext, useContext } from 'react';

const SearchQueryContext = createContext<string>('');

export const useSearchQuery = () => useContext(SearchQueryContext);

export default SearchQueryContext;
